module.exports = __webpack_public_path__ + "img/01.ad06ced2.jpg";